import React from "react";
import { FiExternalLink } from "react-icons/fi";

import { BannersAdmin } from "../../../../../models/BannersModels";
import { DataTable, DataTableColumn } from "../../../../../components/Admin";
import { DangerButton } from "../../../../_layout/AdminLayout.styles";

import { Thumb, Title, Muted, LinkOut } from "./styles";

interface IBannersTable {
  data: BannersAdmin[];
  onDelete: (banner: BannersAdmin) => void;
  deletingId: string;
}

/** O backend grava " " quando o banner não tem link. */
const hasLink = (banner: BannersAdmin) => !!banner.linkurl?.trim();

/** Mostra só o domínio + caminho, sem protocolo, para caber na célula. */
const shortUrl = (url: string) => url.replace(/^https?:\/\/(www\.)?/, "");

const bannerTitle = (banner: BannersAdmin) =>
  banner.title?.trim() || banner.description?.trim() || "";

const BannersTable: React.FC<IBannersTable> = ({
  data,
  onDelete,
  deletingId,
}) => {
  const columns: DataTableColumn<BannersAdmin>[] = [
    {
      key: "thumb",
      header: "",
      width: "180px",
      render: (banner) =>
        banner.url ? <Thumb src={banner.url} alt="" loading="lazy" /> : "—",
    },
    {
      key: "title",
      header: "Banner",
      align: "start",
      render: (banner) =>
        bannerTitle(banner) ? (
          <Title>{bannerTitle(banner)}</Title>
        ) : (
          <Muted>Sem título</Muted>
        ),
    },
    {
      key: "link",
      header: "Link",
      align: "start",
      render: (banner) =>
        hasLink(banner) ? (
          <LinkOut
            href={banner.linkurl}
            target="_blank"
            rel="noopener noreferrer"
            title={banner.linkurl}
          >
            <span>{shortUrl(banner.linkurl)}</span>
            <FiExternalLink size={14} aria-hidden />
          </LinkOut>
        ) : (
          <Muted>Sem link</Muted>
        ),
    },
    {
      key: "position",
      header: "Posição",
      width: "100px",
      render: (banner) => banner.position ?? "—",
    },
    {
      key: "actions",
      header: "Ações",
      width: "140px",
      render: (banner) => (
        <DangerButton
          type="button"
          onClick={() => onDelete(banner)}
          disabled={!!deletingId}
          aria-label={`Excluir o banner ${bannerTitle(banner)}`.trim()}
        >
          {deletingId === banner.bannerid ? "Excluindo..." : "Excluir"}
        </DangerButton>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={data}
      rowKey={(banner) => banner.bannerid}
      emptyMessage="Nenhum banner encontrado."
    />
  );
};

export default BannersTable;
